/*
 * @Author: sunchunyu02@zuoyebang.com
 * @Date: 2020-04-15 15:44:59
 * @LastEditors: 陈秀根
 * @Description: 异步请求API集合
 */
const api = {
  // GET 请求
  get: {
    /**公共接口 */
    getImgCaptcha: '/hxx-passport/service/getImgCaptcha', //获取图片验证码
    getaccountsecurity: '/unitui/user/accountsecurity', // 账号安全
    getConfigInfo: '/opf-manage-ui/app/getConfigInfo', // 获取开发配置信息
    getDevInfo: '/opf-manage-ui/dev/devInfo', // 2.0 机构详情
    getDevDetail: '/opf-manage-ui/dev/devDetail', // 2.0 机构详情_用于编辑
    gethasDev: '/opf-manage-ui/dev/hasDev', // 2.0 判断账户下是否有结构信息
    getAppList: '/opf-manage-ui/app/myAppList', // 2.0 我的应用列表（开发者）
    appInfo: '/opf-manage-ui/app/appInfo', // 2.0 应用详情
    appDetail: '/opf-manage-ui/app/appDetail', // 2.0 应用详情_用于编辑
    getApplyApiList: '/opf-manage-ui/api/getApplyApiList',
    getCanApplyApiList: '/opf-manage-ui/api/getCanApplyApiList',
    getPlatInfo: '/platui/plat/info'
  },

  // POST 请求
  post: {
    login: '/hxx-passport/service/login', //登录接口
    loginByPhone: '/hxx-passport/service/loginByPhone', //手机号验证码登录
    searchApps: '/opf-manage-ui/appStore/search',
    getSmsCode: '/hxx-passport/service/getSmsCode', // 获取手机验证码
    verifySmsCode: '/hxx-passport/service/verifySmsCode', // 短信验证身份获取token,  手机号验证
    passwordReset: '/hxx-passport/service/passwordReset', // 修改账户密码
    bindPhone: '/hxx-passport/service/bindPhone', // 绑定或换绑手机号
    checkLogin: '/opf-manage-ui/login/checkLogin', // 校验ZJXUSS是否登录
    logout: '/hxx-passport/service/logout', // 登出
    updateSsoPage: '/opf-manage-ui/app/updateSsoPage', // 更新sso回调地址
    addDev: '/opf-manage-ui/dev/addDev', // 2.0 登记（添加）机构
    editDev: '/opf-manage-ui/dev/editDev', // 编辑机构
    getAddressTree: '/opf-manage-ui/dic/getaddresstree', // 2.0 获取省市区树
    addApp: '/opf-manage-ui/app/addApp	', // 2.0 登记（添加）应用
    editApp: '/opf-manage-ui/app/editApp', // 2.0 应用编辑
    getUploadParams: '/opf-manage-ui/tool/getUploadParams', // 获取上传参数
    updateDevPhone: '/opf-manage-ui/dev/updateDevPhone', // 修改手机号接口
    commitApply: '/opf-manage-ui/api/commitApply', // 2.1 提交申请（批量）
    delApiAuthRecord: '/opf-manage-ui/api/delApiAuthRecord' // 2.1 删除api申请记录
  },

  // File 请求
  file: {},

  // Websocket 请求
  ws: {}
}
export default api
